<div class="content-box principal-content container">
    <div class="d-flex justify-content-center spinner-content" *ngIf ="finding">
        <div class="py-5">
            <mat-spinner [diameter]="70" [strokeWidth]="2"></mat-spinner>
        </div>
    </div>

    <div class="container content-box">
        <div class="row">
            <div class="col-md-12">
                <button mat-button class="btn-back" mat-raised-button (click)="goBack()">
                    <mat-icon aria-hidden="false" aria-label="keyboard_backspace">keyboard_backspace</mat-icon>
                    {{ 'stt.edit.return' | translate }}
                </button>
            </div>
        </div>
    </div>
    <div class="container content-box">
        <div class="row">
            <div class="col-md-12">
                <p class="principal-title">{{ 'stt.edit.editTranscription' | translate }}</p>
                <div class="content-edition">
                    <mat-grid-list cols="6" rowHeight="6:1">
                        <mat-grid-tile class="meetingInfo"><p style="margin-left:0;">Nº {{ 'stt.edit.meeting' | translate }}</p></mat-grid-tile>
                        <mat-grid-tile class="meetingInfo" style="width: 120px !important;"><p style="margin-left: -40px;">{{ 'stt.edit.file' | translate }}</p></mat-grid-tile>
                        <mat-grid-tile class="meetingInfo"><p style="margin-left:-65px;">{{ 'stt.edit.sesion' | translate }}</p></mat-grid-tile>
                        <mat-grid-tile class="meetingInfo"><p style="margin-left:-80px;">{{ 'stt.edit.committee' | translate }}</p></mat-grid-tile>
                        <mat-grid-tile class="meetingInfo"><p style="margin-left:-40px;">{{ 'stt.edit.transcription' | translate }}</p></mat-grid-tile>
                        <mat-grid-tile class="meetingInfo"><p style="margin-left:0;">{{ 'stt.edit.download' | translate }}</p></mat-grid-tile>

                        <mat-grid-tile class="meetingInfoDisplayed"><p style="margin-left:0;">{{meetingId}}</p></mat-grid-tile>
                        <mat-grid-tile class="meetingInfoDisplayed"><p style="margin-left: -40px;">{{file}}</p></mat-grid-tile>
                        <mat-grid-tile class="meetingInfoDisplayed"><p style="margin-left: -65px;">{{ meetingDate | date:"MMMM d, y" }}</p></mat-grid-tile>
                        <mat-grid-tile class="meetingInfoDisplayed">
                            <label matTooltipClass="stt-tooltip" #tooltip="matTooltip" matTooltipPosition="above" matTooltip="{{topic}}">
                                <p style="margin-left: 0;">{{(topic.length > 40) ? ((topic).slice(0,30) + '...'):topic }}</p>
                            </label>
                        </mat-grid-tile>
                        <mat-grid-tile class="meetingInfoDisplayed"><p style="margin-left: -40px;">{{ transcriptionDate | date:"MMMM d, y" }}</p></mat-grid-tile>
                        <mat-grid-tile class="meetingInfoDisplayed">
                            <button class="button-secondary edit" (click)="DownloadPdf()">
                                <mat-icon aria-hidden="false" aria-label="get_app">get_app</mat-icon>
                            </button>
                        </mat-grid-tile>
                    </mat-grid-list>
                </div>
                <div class="row counter min-counter" >
                    <button class="button-secondary counter d-flex justify-content-start flex-column" style="padding: 10px 10px;width: 215px;">
                        <div class="itemsButton">
                            <mat-icon aria-hidden="false" aria-label="pin">pin</mat-icon>|
                            {{ 'stt.edit.totalWords' | translate }}: {{words}}
                        </div>
                        <div class="itemsButton">
                            <mat-icon aria-hidden="false" aria-label="pin">pin</mat-icon>|
                            {{ 'stt.edit.totalSpeakers' | translate }}: {{orators}}
                        </div>
                    </button>

                    <mat-form-field>
                        <mat-label>
                            <mat-icon aria-hidden="false" aria-label="record_voice_over">
                                record_voice_over
                            </mat-icon>
                            {{ 'stt.edit.speakers' | translate }}
                        </mat-label>
                        <input type="text" aria-label="Number" matInput [formControl]="oratorForm" [matAutocomplete]="auto" >
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option [value]="null" (click)="resetOratorForm()">{{ 'stt.edit.select' | translate }}...</mat-option>
                            <mat-option *ngFor="let user of filterOratorOptions | async" [value]="user">
                                <div (click)="optionClicked($event, user)">
                                    <mat-checkbox [checked]="user.selected" (change)="toggleSelection(user)" (click)="$event.stopPropagation()">
                                        {{user.userName |titlecase}}
                                    </mat-checkbox>
                                </div>    
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    
                    <mat-form-field>
                        <mat-label>
                            <mat-icon aria-hidden="false" aria-label="flag">flag</mat-icon> {{ 'stt.edit.speakersCountry' | translate }}
                        </mat-label>
                        <input [formControl]="countryForm" placeholder="{{ 'stt.edit.director_placeholder' | translate }}" matInput type="text"
                            [matAutocomplete]="countryAuto" #countryF>
                        <mat-autocomplete autoActiveFirstOption #countryAuto="matAutocomplete">
                            <mat-option [value]="null" (click)="resetCountryForm()">{{ 'stt.edit.select' | translate }}...</mat-option>
                            <mat-option *ngFor="let opt of filterCountryOptions | async" [value]="opt.name">
                                {{ opt.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>
                            <mat-icon aria-hidden="false" aria-label="notes">
                                notes
                            </mat-icon>
                            {{ 'stt.edit.keywords' | translate }}
                        </mat-label>
                        <input [formControl]="textForm" matInput placeholder="{{ 'stt.edit.keyword_placeholder' | translate }}">
                    </mat-form-field>
                    <button class="btnFiltrar" (click)="filterTranscription()">
                        {{ 'stt.edit.search' | translate }}
                    </button>
                </div>
            </div>
            
            <div class="col-md-12" *ngIf="transcriptions">
                <div class="content-text">
                    <h2 class="title-text">{{titleTable}}</h2>
                    <div class="table-result">
                        <table mat-table class="w-100" [dataSource]="transcriptionList" matSort aria-label="Elements">
                            <caption></caption>
                            <ng-container matColumnDef="transcriptionDetails">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="display: block;" scope="col"></th>

                                <td mat-cell *matCellDef="let row; let x = index">
                                    <div [ngClass]="{
                                        'Parrafo-top': x === 0 || row.interventionOrder !== transcriptionList[ x-1 ]?.interventionOrder, 
                                        'Parrafo': x >= 0,
                                        'Parrafo-bottom': row.interventionOrder !== transcriptionList[ x+1 ]?.interventionOrder 
                                      }">
                                        <div class="col-md-12" *ngIf=" x === 0 || row.interventionOrder !== transcriptionList[ x-1 ]?.interventionOrder">
                                            <div class="col-md-6 orange-text">
                                                <span>{{ 'stt.edit.speaker' | translate }}: {{ row.orador }} {{ row.startTrack | date:"HH:mm:ss" }}.&nbsp;</span>
                                              
                                              <span>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{ 'stt.edit.edition' | translate }}: {{row.modifyBy}} {{ row.dateModify }}</span>
                                            </div>
                                        </div>

                                        <div id="id-{{row.startTrack}}" class="col-md-12" style="display: flex; align-items: center;">
                                            <!-- <div class="col-md-11" style="display: flex;"> -->

                                                <mat-form-field class="textInput" [ngClass]="{
                                                    'firstWidth': row.orador !== transcriptionList[ x-1 ]?.orador, 
                                                    'defaultWidth': x > 0,
                                                    'lessWidth': (row.versionNumber != 1 || row.versionNumber == 1 ) && row.existInVersion == false && ( x === 0 || row.orador !== transcriptionList[ x-1 ]?.orador) 
                                                  }" aspect = "">
                                                    <textarea id="p-{{row.startTrack}}" cdkTextareaAutosize matInput #textArea style="overflow:hidden">{{row.transcriptionText}}</textarea>
                                                </mat-form-field>
                                            <!-- </div> -->

                                            <div [ngClass]="{
                                                'buttons': x >= 0,
                                                'moreButtons': (row.versionNumber != 1 || row.versionNumber == 1 ) && row.existInVersion == false && ( x === 0 || row.orador !== transcriptionList[ x-1 ]?.orador) 
                                              }">

                                                <label style="position: relative" *ngIf="row.existInVersion == false && ((row.versionNumber != 1 || row.versionNumber == 1 ) && row.existInVersion == false && ( x === 0 || row.orador !== transcriptionList[ x-1 ]?.orador)) " matTooltipClass="stt-tooltip" #tooltip="matTooltip" matTooltipPosition="above" matTooltip="{{ 'sst.edit.transcriptionSaved' | translate }}">
                                                    <mat-icon aria-hidden="false" aria-label="create" style="margin-right: 2px;margin-left: 2px;">
                                                        create
                                                    </mat-icon>
                                                </label>

                                                <label matTooltipClass="stt-tooltip" #tooltip="matTooltip" matTooltipPosition="above" matTooltip="{{ 'stt.edit.saveEdit' | translate }}">
                                                    <button class="icons" (click)="saveChangesTranscription(row.transcriptionId, textArea.value, row)">
                                                        <mat-icon aria-hidden="false" aria-label="save">save</mat-icon>
                                                    </button>
                                                </label>

                                                <label matTooltipClass="stt-tooltip" #tooltip="matTooltip" matTooltipPosition="above" matTooltip="{{ 'stt.edit.otherEdition' | translate }}">
                                                    <button class="icons" (click)="openModalPreviousEditions(row.sentenceId)"
                                                    *ngIf="row.versionNumber != 1">
                                                        <mat-icon aria-hidden="false" aria-label="remove_red_eye">remove_red_eye</mat-icon>
                                                    </button>
                                                </label>

                                                <label matTooltipClass="stt-tooltip" #tooltip="matTooltip" matTooltipPosition="above" matTooltip="{{ 'stt.edit.noEdit' | translate }}">
                                                    <button class="icons" *ngIf="row.versionNumber == 1">
                                                        <mat-icon aria-hidden="false" aria-label="visibility_off">visibility_off</mat-icon>
                                                    </button>
                                                </label>

                                                <label *ngIf=" x === 0 || row.interventionOrder !== transcriptionList[ x-1 ]?.interventionOrder" matTooltipClass="stt-tooltip" #tooltip="matTooltip" matTooltipPosition="above" matTooltip="Audio">
                                                    <button class="icons" (click)="openModalAudio(i, row, topic)">
                                                        <mat-icon aria-hidden="false" aria-label="headset">headset</mat-icon>
                                                    </button>
                                                </label>

                                                <label style="position: relative" *ngIf="row.existInVersion == false && !( (row.versionNumber != 1 || row.versionNumber == 1 ) && row.existInVersion == false && ( x === 0 || row.orador !== transcriptionList[ x-1 ]?.orador)) " matTooltipClass="stt-tooltip" #tooltip="matTooltip" matTooltipPosition="above" matTooltip="{{ 'sst.edit.transcriptionSaved' | translate }}">
                                                    <mat-icon aria-hidden="false" aria-label="create" style="margin-right: 8px;">
                                                        create
                                                    </mat-icon>
                                                </label>

                                            </div>
                                          
                                        </div>

                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"
                                [class.selected]="row.isSelected"></tr>
                        </table>
                    </div>
                </div>
                <div class="content-button" *ngIf="result">
                    <button class="button-primary" (click)="postNewVersion(idMeet)">{{ 'stt.edit.public' | translate }}</button>
                </div>
            </div>
        </div>
    </div>